import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { DataModelConfiguration } from "../../../api/types/dataModelConfigurationTypes";
import type { ObjectClassDefinition, ObjectClassDefinitionInfo } from "../../../api/types/objectTypes";

export interface Props {
  objectDefinition: ObjectClassDefinition;
  onUpdateObjectDefinition: (objectDefinition: ObjectClassDefinition) => void;
  configurations: DataModelConfiguration[];
  allObjectDefinitions: ObjectClassDefinitionInfo[];
}

interface ContextValue extends Props {
  hasEditPermissions: boolean;
}

export const ObjectDefinitionContext = createContext<ContextValue | undefined>(undefined);

export const useObjectDefinitionContext = () =>
  defined(use(ObjectDefinitionContext), "Attempt to use ObjectDefinitionContext without provider");
